import * as React from 'react';
import Config from '../../config/Config';
import DynamicInputField, { Field } from '../../components/dynamic-input-field/DynamicInputField';
import FormFooter from '../../components/form-footer/FormFooter';
import Stepper, { StepProps } from '../../components/stepper/Stepper';

import style from './FormPage.module.css';
import { appendFile } from 'fs';
import { JsxElement } from 'typescript';
import DynamicCheckBoxField from '../../components/dynamic-checkbox-field/DynamicCheckBoxField';
import DynamicRadioField from '../../components/dynamic-radio-field/DynamicRadioField';
import DynamicSelectionField from '../../components/dynamic-selection-field/DynamicSelectionField';
import Agreement from '../../components/agreement/Agreement';
import TimePicker from '../../components/time-picker/TimePicker';

type FormProps = {
    loading: boolean,
    failed: boolean,
    page: Page,
    api: any
}

type Page = {
    title: string,
    header: string,
    subHeader: string,
    fields: Field[],
    onPrevious?: Function,
    onNext?: Function,
    onLoad?: Function
}

const FormPage = (props: FormProps) => {
    if(props.loading){
        return <div id={style.container} className={`${style.centeredContent} ${style.noSelect}`}>
            <h1 id={style.noFormSelected}>Loading..</h1>
        </div>
    }

    if(props.failed) {
        return <div id={style.container} className={`${style.centeredContent} ${style.noSelect}`}>
            <h1 id={style.noFormSelected}>Something went wrong.</h1>
        </div>
    }

    if (!props.page) {
        return <div id={style.container} className={`${style.centeredContent} ${style.noSelect}`}>
            <h1 id={style.noFormSelected}>Page not found.</h1>
        </div>
    }

    const TemplateHeader = React.lazy(() => { return import('../../' + Config.namespace + '/templates/TemplateHeader') });
    const TemplateFooter = React.lazy(() => { return import('../../' + Config.namespace + '/templates/TemplateFooter') });

    const validateFields = (fields: Field[]) => {
        let valid = true;
        for(const field of fields){
            if(!field.validation?.()){
                valid = false;
            }
        }
        return valid;
    }

    const previousButton = props.page.onPrevious ? ()=>{props.page.onPrevious?.(props.api)} : undefined;
    const nextButton = props.page.onNext ? ()=>{
        const fieldValidation = validateFields(props.api.form.pages[props.api.page].fields);
        if(props.api.store.customFields){
            const customFieldValidation = validateFields(props.api.store.customFields);
            if(fieldValidation && customFieldValidation){
                props.page.onNext?.(props.api);
            }
            return;
        }
        if(fieldValidation){
            props.page.onNext?.(props.api);
        }
    } : undefined;
    return (
        <div id={style.container}>
            <div id={style.content}>
                <React.Suspense>
                    <TemplateHeader></TemplateHeader>
                </React.Suspense>
                <Stepper api={props.api}></Stepper>
                <div id={style.body}>
                    <div id={style.title}>{props.page.title}</div>
                    <div id={style.header}>{props.page.header}</div>
                    <div id={style.subheader}>{props.page.subHeader}</div>
                    {
                        props.page.fields?.map((field: Field, index: number) => {
                            field.regex = Config.getRegexForType(field.type);
                            if(field.type == 'select'){
                                return <DynamicSelectionField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicSelectionField>
                            }
                            if(field.type == 'checkbox'){
                                return <DynamicCheckBoxField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicCheckBoxField>
                            }
                            if(field.type == 'radio'){
                                return <DynamicRadioField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicRadioField>    
                            }
                            if(field.type == 'agreement'){
                                return <Agreement key={index + '_' + field.type + '_async'} api={props.api} field={field}></Agreement>
                            }
                            return <DynamicInputField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicInputField>
                        })
                    }
                    {
                        props.api.store.customFields?.map((field: Field, index: number) => {
                            field.regex = Config.getRegexForType(field.type);
                            field.custom = true;
                            if(field.type == 'select'){
                                return <DynamicSelectionField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicSelectionField>
                            }
                            if(field.type == 'checkbox'){
                                return <DynamicCheckBoxField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicCheckBoxField>
                            }
                            if(field.type == 'radio'){
                                return <DynamicRadioField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicRadioField>    
                            }
                            if(field.type == 'agreement'){
                                return <Agreement key={index + '_' + field.type + '_async'} api={props.api} field={field}></Agreement>
                            }
                            if(field.type == 'time'){
                                return <TimePicker key={index + '_' + field.type + '_async'} api={props.api} field={field}></TimePicker>
                            }
                            return <DynamicInputField key={index + '_' + field.type + '_async'} api={props.api} field={field}></DynamicInputField>
                        })
                    }
                    {props.api.store.customElements}
                    <FormFooter leftButtonOnClick={previousButton} rightButtonOnClick={nextButton}></FormFooter>
                </div>
                <React.Suspense>
                    <TemplateFooter></TemplateFooter>
                </React.Suspense>
            </div>
        </div>
    )
}

export default FormPage;
export type { Page };